import { TemplateResult } from 'lit';

export enum PersonalisationStepId {
  TYPE,
  UPLOAD_SELECT_FILE,
  UPLOAD_PROCESS,
  COLORS_SOURCE,
  PICK_COLORS,
  PICK_COLORS_WITH_FILE,
  TEXT,
  TEXT_WITH_FILE,
  DONE,
}

export type PersonalisationStep = {
  id: PersonalisationStepId;
  titleTranslationKey: string;
};

export type PersonalisationFlow = PersonalisationStep[];

export enum PersonalisationType {
  LOGO = 'image',
  LOGO_TEXT = 'text_image',
  TEXT = 'text',
}

export enum ChosenPersonalisationType {
  DEFAULT = 'default',
  MANUAL = 'manual',
  VISUAL_DESIGNER = 'visual_designer',
}

export type PersonalisationTypeOption = {
  type: PersonalisationType;
  icon: TemplateResult;
  titleTranslationKey: string;
  descriptionTranslationKey: string;
};

export type PersonalisationTypeOptions = PersonalisationTypeOption[];

export interface PersonalisationTypes {
  [key: string]: {
    title: string;
    logo?: string;
    description?: string;
    fontFamily?: string | null;
  };
}
